<template>

<div class="container">

    <div class="row justify-content-center">

        <div class="col-12 col-lg-3 mb-2" >
            <label class="text-small mb-0">Search by title</label>
            <input type="text" id='srch-field'
                    @focusin='isFocused = true' 
                    @focusout='hideResults' 
                    @keyup='textFilter($event)'
                   class='form-control' :placeholder="inputText" v-model='filter.search'>

            <div id='sb-results' v-show='isFocused'>
                <div v-for='(title,url) in results' class='result-item'>
                    <a :href='url' target="_blank">{{ title }} </a>
                </div>
            </div>
        </div>

        <div class="col-12 col-md-6 col-lg-3 mb-3">
            <label class="text-small mb-0">Filter by Category</label>
            <select @change='filterResults' class='form-control' placeholder="Category" v-model='filter.category'>
                <option :value='null'>All</option>
                <option v-for='(c,i) in cats' :value='i'>{{ c }}</option>
            </select>
        </div>

        <div class="col-6 col-md-3 mb-3">
            <label class="text-small mb-0">Filter by Time</label>
            <select @change='filterResults' class='form-control' placeholder="Category" v-model='filter.date'>
                <option :value='null'>All Time</option>
                <option value='today'>Today</option>
                <option value='week'>This Week</option>
                <option value='month'>This Month</option>
            </select>
        </div>

        <div class="col-6 col-md-3 mb-3">
            <label class="text-small mb-0">Sort By</label>
            <select @change='filterResults' class='form-control' v-model='filter.sort'>
                <!-- <option :value='null'>Sort By</option> -->
                <option value='new'>Recently Added</option>
                <option value='p'>Popular</option>
                <option value='f'>Featured</option>
            </select> 
        </div>

    </div>

</div>

</template>

<script>
    export default {

        mounted() {
            var me = this;

            bus.$on('filter-reset', () => {
                me.filter = {
                    search  : '',
                    sort    : 'new',
                };
            })

            this.getCats();
        },

        props : ['c'],

        created() {
            
            // if( typeof this.c != 'undefined' ) {
            //     this.filter.category = this.c;
            // }

        },

        data() { 

            return {
                isReady : false,
                inputText : "Search for news",

                filter : {
                    search   : '',
                    category : null,
                    sort     : 'new',
                    date     : null
                },

                cats : [],

                filterLoading : false,

                isFocused : false,
                results : [],

                catResults : [],

                toolData : false
            }
            
        },

        methods : {


            hideResults : _.debounce( function() {
                this.isFocused = false;
            } ,200),


            toggle(t) {
                if( this.filter.tags.includes(t.id) ) {
                    this.filter.tags.splice( this.filter.tags.indexOf(t.id), 1);
                } else {
                    this.filter.tags.push( t.id );
                }
            },

            filterResults() {
                bus.$emit('filter-rss', this.filter );
                $("#filterModal").modal('hide');
            },

            textFilter( ev ) {
                if( ev.key == "Enter" || ev.keyCode == 13 ) {
                    bus.$emit('filter-rss', this.filter );

                    $("#srch-field").blur();
                    return;
                }

                if( ev.key == "Escape" || ev.keyCode == 27 ) {
                   
                   this.filter.search = '';
                   return;
                }

                if( this.filter.search < 2 ) {
                    return;
                }

                this.filterLoading = true;

                this._tf();
            },

            _tf : _.debounce( function() {

                var me = this,
                    params = {
                        s : me.filter.search
                    };


                me.ajax.call('rf:gac', params, (r) => {

                    if( r.status == 'success' ) { 

                        me.results = r.data;

                    } else {
                        
                        $.notify( r.message, 'warning');

                    }

                    me.filterLoading = false;
                })
                
            }, 500),

            getCats() {

                this.ajax.call('rf:gct', {}, (r) => {

                    if( r.status == 'success' ) { 

                        this.cats = r.data;

                    } else {
                        
                        $.notify( r.message, 'warning');

                    }

                })
            },

            shouldShow(r) {
                if( !this.filter.search ) {
                    return true;
                }

                return r.title.toLowerCase().includes( this.filter.search.toLowerCase() );
            }
        }

    }
</script>